import "./index.scss";
const Loader = () => {
    return (
        <div className="loading-container">
            <span className="loading" />
        </div>
    );
};

export default Loader;
